<template>
    <Modal v-model="visible" title="选择协议中包含的产品" width="1100" :mask-closable="false" :footer-hide="true" class="top ">
        <div class="search-box">
            <div class="input-item" style="width:300px;">
                <span class="label">产品code/名称</span>
                <Input class="value" v-model="searchObj.productCodeOrName" placeholder="请输入" clearable />
            </div>
            <Button type="primary" @click="pageChange(1)">查询</Button>
        </div>

        <loading :isShow="$root.$children[0].isShowLoading" />

        <div class="all-select">
            <Checkbox v-model="checkboxIsAll" @on-change="selectCheckboxIsAll">全部产品</Checkbox>
            <span
                >已选中<span class="select-num">{{ selectCount }}</span
                >项</span
            >
        </div>
        <div class="table-box setTable">
            <Table
                :columns="columns"
                ref="selection"
                :data="productList"
                row-key="id"
                @on-select-all-cancel="tableSelectAllCancel"
                @on-select-all="selectAll"
                @on-select="selectRow"
                @on-select-cancel="selectRowCancel"
                @on-expand-tree="onExpand"
            ></Table>
        </div>

        <div class="pageBox">
            <Page
                :total="total"
                :current="searchObj.pageNo"
                :page-size="searchObj.pageSize"
                show-total
                @on-change="pageChange"
                style="text-align: center;margin-top: 20px;;"
            />
        </div>

        <div class="ivu-modal-footer">
            <Button type="text" @click="visible = false">取消</Button>
            <Button type="primary" @click="save">确认</Button>
        </div>
    </Modal>
</template>

<script>
export default {
    props: ['initProductList', 'covenantId'],
    data() {
        return {
            visible: false,
            tableData: [],
            productList: [],
            total: 0,
            checkboxIsAll: false, //是否全选中
            selectArr: [], //已选中数据
            filterCodes: [], //全选后，已取消的个别数据
            searchObj: {
                pageNo: 1,
                pageSize: 5
            },
            columns: []
        };
    },
    computed: {
        selectCount() {
            let count = 0;
            if (this.checkboxIsAll) {
                const arr = this.filterCodes.filter(item => item.productType == 1); //获取主险
                count = this.total - arr.length;
            } else {
                count = this.selectArr.length;
            }
            this.$nextTick(()=>{//避免死循环
                if(count==0&&(this.checkboxIsAll||this.selectArr.length||this.filterCodes.length)) {
                    this.checkboxIsAll = false;
                    this.selectArr = []; //已选中数据
                    this.filterCodes = []; //全选后，已取消的个别数据 
                }
            })
            return count
        }
    },
    methods: {
        async open() {
            this.visible = true;
            this.searchObj.pageNo = 1;
            this.initList();
            this.checkboxIsAll = false; //是否全选中
            this.selectArr = []; //已选中数据
            this.filterCodes = []; //全选后，已取消的个别数据
            let col = [
                {
                        type: 'selection',
                        width: 50,
                        align: 'center'
                    },
                    {
                        title: '产品code',
                        minWidth: 110,
                        align: 'center',
                        tree: true,
                        key: 'productCode'
                    },
                    {
                        title: '产品名称',
                        minWidth: 200,
                        align: 'center',
                        key: 'productName'
                    },
                    {
                        title: '保司名称',
                        minWidth: 200,
                        align: 'center',
                        key: 'companyName'
                    },
                    {
                        title: '险种分类',
                        minWidth: 80,
                        align: 'center',
                        render(h, params) {
                            return <span>{params.row.themeName ? params.row.themeName : '-'}</span>;
                        }
                    },
                    {
                        title: '供应商',
                        minWidth: 90,
                        align: 'center',
                        key: 'supplierName' 
                    },
                    {
                        title: '险种code',
                        minWidth: 80,
                        align: 'center',
                        key: 'insuranceCode'
                    },
                    {
                        title: '险种名称',
                        minWidth: 200,
                        align: 'center',
                        key: 'insuranceName'
                    },
                    {
                        title: '主附险类型',
                        width: 100,
                        align: 'center',
                        render(h, params) {
                            const productType = params.row.productType;
                            return <span>{productType == '1' ? '主险' : '附加险'}</span>;
                        }
                    }
            ]
            if(!this.$units.superviseShowVal()){
                col.splice(5, 1);
            }
            this.columns = col;
        },

        initList() {
            this.$root.$children[0].isShowLoading = true;
            this.$http({
                url: '/buz/covenantProduct/queryAdd',
                type: 'POST',
                data: {
                    covenantId: this.covenantId,
                    ...this.searchObj
                }
            }).then(res => {
                this.total = res.total;
                this.$root.$children[0].isShowLoading = false;
                this.productList = this.handleTableTree(res.data);
            });
        },
        // 处理树形数据
        handleTableTree(arr) {
            const arr1 = this.selectArr.map(item => item.id);
            const arr2 = this.filterCodes.map(item => item.id);
            return arr.map(item => ({
                ...item,
                children: item.additionalList ? this.handleTableTree(item.additionalList) : [],
                id: item.insuranceCode + item.productCode + item.productType,
                _checked:
                    arr1.includes(item.insuranceCode + item.productCode + item.productType) ||
                    (!arr2.includes(item.insuranceCode + item.productCode + item.productType) && this.checkboxIsAll),
                _showChildren: true
            }));
        },

        // 分页
        pageChange(pageNo) {
            this.searchObj.pageNo = pageNo;
            this.selectArr = [];
            this.initList();
        },
        // 展开或收起某一行
        onExpand(id, status) {
            const tableItem = this.productList.find(item => item.id == id);
            tableItem._showChildren = status;
        },
        // 选中某个
        selectRow(list, data) {
            const tableItem = this.productList.find(item => item.productCode == data.productCode);
            tableItem._checked = true;
            const selectArr = [tableItem];
            if (data.productType == 1) {
                //点击的是主险
                if (tableItem.children && tableItem.children.length) {
                    tableItem.children.forEach(item => {
                        item._checked = true;
                        selectArr.push(item);
                    });
                }
            } else {
                tableItem.children.forEach(item => {
                    if (item.id == data.id) {
                        item._checked = true;
                        selectArr.push(item);
                    }
                });
            }
            if (this.checkboxIsAll) {
                //全选状态
                this.filterCodes = this.delData(this.filterCodes, selectArr);
            } else {
                this.selectArr = this.addData(this.selectArr, [tableItem]);
            }
        },
        // 取消某个
        selectRowCancel(list, data) {
            const tableItem = this.productList.find(item => item.productCode == data.productCode);
            const filterCodes = [];
            if (data.productType == 1) {
                //点击的是主险
                filterCodes.push(tableItem);
                tableItem._checked = false;
                if (tableItem.children && tableItem.children.length) {
                    tableItem.children.forEach(item => {
                        item._checked = false;
                        filterCodes.push(item);
                    });
                }
            } else {
                tableItem.children.forEach(item => {
                    if (item.id == data.id) {
                        item._checked = false;
                    }
                    if (!item._checked) {
                        filterCodes.push(item);
                    }
                });
                // 非全选取消附加险也要排除
                this.filterCodes = this.addData(this.filterCodes, filterCodes);
            }
            if (this.checkboxIsAll) {
                //全选状态
                this.filterCodes = this.addData(this.filterCodes, filterCodes);
            } else if (data.productType == 1) {
                this.selectArr = this.delData(this.selectArr, [tableItem]);
            }
        },

        // 点击当前页全选
        selectAll(data) {
            if (this.checkboxIsAll) {
                //全选时
                this.filterCodes = this.delData(this.filterCodes, data);
            } else {
                //没有全选时
                this.selectArr = this.addData(this.selectArr, this.productList);
            }
            this.handleTableAllSelectTree(true);
        },

        // 取消当前分页全选
        tableSelectAllCancel(data) {
            if (this.checkboxIsAll) {
                //全选时
                const filterCodes = [];
                this.productList.forEach(item => {
                    filterCodes.push(item);
                    if (item.children && item.children.length) {
                        item.children.forEach(item2 => {
                            filterCodes.push(item2);
                        });
                    }
                });
                this.filterCodes = this.addData(this.filterCodes, filterCodes);
            } else {
                //没有全选时
                this.selectArr = this.delData(this.selectArr, this.productList);
            }
            this.handleTableAllSelectTree(false);
        },

        // 全选
        selectCheckboxIsAll(value) {
            this.selectArr = [];
            this.filterCodes = [];
            this.handleTableAllSelectTree(value);
        },

        // 全选/取消全选
        handleTableAllSelectTree(value) {
            this.productList.forEach(item => {
                item._checked = value;
                if (item.children && item.children.length) {
                    item.children.forEach(item2 => {
                        item2._checked = value;
                    });
                }
            });
        },
        // 添加数据
        addData(list, data) {
            const ids = list.map(item => item.id);
            data = data.filter(item => !ids.includes(item.id)); //过滤已添加
            return list.concat(data);
        },
        // 删除数据
        delData(list, data) {
            const ids = data.map(item => item.id);
            return list.filter(item => !ids.includes(item.id));
        },

        save() {
            if (this.selectCount == 0) {
                this.$Message.error('请选择产品');
                return;
            }
            const filterCodes = this.filterCodes.map(item => {
                return item.insuranceCode + '*' + item.productCode + '*' + item.productType;
            });
            const filterIds = this.filterCodes.map(item =>item.id)
            const selectArr = JSON.parse(JSON.stringify(this.selectArr));
            selectArr.forEach(item => {
                delete item.id;
                if(this.filterCodes.length && !this.checkboxIsAll){//存在非全选情况，并去掉了主险下的附加险
                    item.additionalList = [];
                }
                if (item.children && item.children.length) {
                    item.children.forEach(item2 => {
                        if(this.filterCodes.length && !this.checkboxIsAll&&!filterIds.includes(item2.id)){//存在非全选情况，并去掉了主险下的附加险
                            item.additionalList.push(item2)
                        }
                        delete item2.id;
                    });
                }
            });
            let data = {
                covenantId: this.covenantId,
                ...this.searchObj
            };
            if (this.checkboxIsAll) {
                data.isAll = '1'; //全选
                data.filterCodes = filterCodes;//全选后，已取消的个别数据
            } else {
                data.covenantProductDTOS = selectArr;
            }

            this.$http({
                url: '/buz/covenantProduct/add',
                type: 'POST',
                data,
                apiPermissionCode:'pro_6_3'
            }).then(res => {
                this.$notice.success('提交成功');
                this.initProductList();
                this.visible = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/.ivu-modal-header-inner {
    font-size: 14px;
    font-weight: bold;
    color: #3c464f;
}
/deep/.ivu-modal-close {
    top: 4px;
    .ivu-icon-ios-close {
        font-size: 30px;
        color: #a8adb7;
    }
}
/deep/.ivu-modal-header {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
}

.all-select {
    margin-left: 18px;
    margin-bottom: 20px;
    span {
        margin-left: 30px;
        .select-num {
            margin-left: 0px;
            color: #236dff;
            font-weight: bold;
        }
    }
}
</style>
